import bg from "assets/images/background/image-2.jpg";

const parallaxSection = {
  bg,
  icon: "flaticon-app-development",
  title: "Great things in business are never done by one person.",
  title2: "They’re done by a team of people.",
};

export const parallaxPage = [
  {
    id: 1,
    bg: "parallax-bg-1-1.jpg",
    title: "Hand drawn Painting",
  },
  {
    id: 2,
    bg: "parallax-bg-1-2.jpg",
    title: "Creative Shop branding",
  },
  {
    id: 3,
    bg: "parallax-bg-1-3.jpg",
    title: "Stunning Photography",
  },
  {
    id: 4,
    bg: "parallax-bg-1-4.jpg",
    title: "Illustration art Work",
  },
];

export default parallaxSection;
